import React from "react";
import CustomTooltip from "../../../Core/Components/CustomTooltip";
import { BATTERY_STATUS } from ".";

const AssociatedWithColumn = ({ record }) => {
  if (record?.trikeRegistrationNo) {
    return (
      <div>
        <CustomTooltip tooltipTitle={record.trikeRegistrationNo}>
          <div className="text-xs font-semibold font-aileron text-dark-gray capitalize whitespace-nowrap">
            {record.trikeRegistrationNo.length > 10
              ? `${record.trikeRegistrationNo.substring(0, 10)}...`
              : record.trikeRegistrationNo}
          </div>
        </CustomTooltip>

        <p className="text-10 font-medium font-aileron leading-12 text-dark-gray capitalize">
          {record?.driverFirstName
            ? `${record.driverFirstName} ${record?.driverLastName}`
            : ""}
        </p>
      </div>
    );
  }

  if (
    +record.status === BATTERY_STATUS.IN_SESSION &&
    record.paAssetRegistrationNo
  ) {
    return (
      <div>
        <CustomTooltip tooltipTitle={record.paAssetRegistrationNo}>
          <div className="text-xs font-semibold font-aileron text-dark-gray capitalize whitespace-nowrap">
            {record.paAssetRegistrationNo.length > 10
              ? `${record.paAssetRegistrationNo.substring(0, 10)}...`
              : record.paAssetRegistrationNo}
          </div>
        </CustomTooltip>

        <p className="text-10 font-medium font-aileron leading-12 text-dark-gray capitalize">
          {record?.driverFirstName
            ? `${record.driverFirstName} ${record?.driverLastName}`
            : ""}
        </p>
      </div>
    );
  }

  return (
    <div>
      <CustomTooltip tooltipTitle={record.currentHubName}>
        <div className="text-xs font-semibold font-aileron text-dark-gray capitalize whitespace-nowrap">
          {record.currentHubName.length > 10
            ? `${record.currentHubName.substring(0, 10)}...`
            : record.currentHubName}
        </div>
      </CustomTooltip>
    </div>
  );
};

export default AssociatedWithColumn;
